
<template>
  <div class="card">
    <div class="card-body text-right">
      <button @click="getAuditLog()" class="btn btn-primary" data-toggle="modal" data-target="#modal-audit-details">View Audit Log</button>
      <h2>Updated By: </h2>
      User: {{createdBy}}<br />
      Date: {{updatedAt}}
      <h2>Created By</h2>
      User: {{createdBy}}<br />
      Date: {{createdAt}}
      <h2>Status</h2>
      Ready to Run: {{jobInfo.ready}}<br />
      Scheduled for Later: {{jobInfo.scheduled}}<br />
      Failed Jobs: {{jobInfo.failed}}<br />
    </div>

    <div class="modal modal-blur fade" id="modal-audit-details" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Audit Log</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
          <div class="modal-body">
            <ul>
              <li :key="audit.id" v-for="audit in auditData">[{{audit.added}}] {{audit.data}} by <strong>[{{audit.updatedBy}}]</strong></li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>



<script>
  import WebLLCRESTApi from "../api/api";
  export default {
    data() {
      return {
        auditData: []
      }
    },
    props: {
      clientId: String,
      updatedBy: String,
      updatedAt: Date,
      createdBy: String,
      createdAt: Date,
      jobInfo: Object,
    },
    methods: {
      async getAuditLog() {
        const api = new WebLLCRESTApi("Client-Audits", this.$router);          
        this.auditData = await api.getData(null, {
          "where": { clientId: this.clientId },
          "order": "added DESC"
        });
        
      }
    }
    
   

  }
</script>



// WEBPACK FOOTER //
// src/components/AuditLog.vue